import { Producer } from "Models/producer";
import { Message } from "Models/message";

export const getProducer = (state: any): Producer => state.producer;
export const getRecentMessage = (state: any): Message | null =>
    getProducer(state)?.recentMessage ?? null;
